import { Dispatch } from "redux";
import api from "../../api/api";
import { setPointData, resetPointData, resetCourseList } from "../reducers/getAiFeedbackPointByTeacherReducer";

const getAiFeedbackPointByTeacher = (
    token: any,
    students: any[],
    selectedcourselist: any[],
    time_period: any,
    month_year: any,
    avg_score: any,
    week_start_date: any,
    daily_date: any,
    start_date: any,
    end_date: any,
    role: any,
    student_id: any,
    overall_average: any
) => async (dispatch: Dispatch) => {
    try {
        dispatch(resetPointData());

        const studentsString = students.join(',');
        const coursesString = selectedcourselist.join(',');
        // const coursesString = [455545, 403088, 206127, 539817, 393859, 477897, 515405, 289411, 206375, 385492, 996043, 548879, 993509, 839662, 839118, 898489, 890585, 800096, 197610, 964044, 240050, 721346, 663893, 576099, 771106, 494642, 751253].join(',');

        const params: any = {
            courses: coursesString,
            time_period,
            avg_score,
            ...(month_year && { month_year }),
            ...(week_start_date && { week_start_date }),
            ...(daily_date && { daily_date }),
            ...(start_date && { start_date }),
            ...(end_date && { end_date }),
        };

        // console.log("month_year:", month_year);
        

               // Conditionally include parameters based on `time_period`
        if (time_period === 'year') {
            // For 'year' time period, include month_year in MMM-YYYY format
            delete params.daily_date; // Ensure daily_date is not included for 'year'
        } else if (time_period === 'month') {
            // For 'month' time period, include `week_start_date` and exclude `daily_date`
            if (week_start_date) {
                params.week_start_date = week_start_date;
            }
            if (month_year) {
                params.month_year = month_year;
            }
            delete params.daily_date; // Ensure daily_date is not included for 'month'
        } else if (time_period === 'week' || time_period === 'custom') {
            // For 'week' and 'custom' time periods, pass `daily_date`
            if (daily_date) {
                params.daily_date = daily_date;
            }
            if (month_year) {
                params.month_year = month_year;
            }
        }

        if (role === "Student") {
            params.student_id = student_id; // For student, use student_id instead of students
             params.overall_avg_score = overall_average;
        } else {
            params.student_ids = studentsString; // For teacher, use studentsString
            params.overall_avg_score = overall_average; // Include overall_avg_score for teacher
        }

        const endpoint = role === "Student"
            ? `/analytics/dashboard/student/performance/`
            : `/analytics/dashboard/teacher/performance/`;

        const result = await api.get(endpoint, {
            params,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setPointData(result?.data || []));
        }
    } catch (error: any) {
        console.error("Error fetching point data:", error);
    }
};

export { getAiFeedbackPointByTeacher, resetCourseList };



